import {BaseModel} from '../base/BaseModel';

/**
 * @class WeatherModel
 * @extends BaseModel
 *
 * @property {object} attributes
 */
export class WeatherModel extends BaseModel {

    get defaults () {

        return {
            foreignUuid : '',
            date: '',
            maxAirTemp: '',
            minAirTemp: '',
            currentHour: '',
            currentHourAirTemp: '',
            currentHourWeatherDescriptorIcon: '',
            currentHourWindSpeed: '',
            currentHourWindDirectionDescriptorText: '',
            currentHourRelativeHumidity: '',
            currentHourAccRainfall: '',
            currentHourRainfallProbability: '',
            currentHourCloudCover: '',
            currentHourSoilTemp10cmBg: '',
            currentHourSoilMoisture200cmBg: '',
            currentHourShortWaveRadiation: '',

            // COLORING PROPS
            sprayWeatherWindSpeed: '',
            sprayWeatherAirTemp: '',
            sprayWeatherRelativeHumidity: '',
            sprayWeatherAccRainfall: '',
            sprayWeatherDeltaT: '',
            sprayWeatherAggregated: '',
        };
    }

    parse (modelToParse) {

        modelToParse.date = BaseModel.parseDate(modelToParse.date);
        modelToParse.datetime = BaseModel.parseDate(modelToParse.datetime);
        modelToParse.startDatetime = BaseModel.parseDate(modelToParse.startDatetime);
        modelToParse.endDatetime = BaseModel.parseDate(modelToParse.endDatetime);

        return modelToParse;
    }

    static get SPRAY_WEATHER_CONDITION () {

        return {
            BAD: 'RED',
            GOOD: 'GREEN',
            NORMAL: 'ORANGE'
        };
    }

    static get ICON_NAMES () {

        return {
            ERROR_NONE: 'error_none',
            COVER_SUN: 'cover_sun',
            COVER_MOON: 'cover_moon',
            COVER_MOSTLY_CLEAR_DAY: 'cover_mostlyclearday',
            COVER_MOSTLY_CLEAR_NIGHT: 'cover_mostlyclearnight',
            COVER_PARTLY_CLOUDY_DAY: 'cover_partlycloudyday',
            COVER_PARTLY_CLOUDY_NIGHT: 'cover_partlycloudynight',
            COVER_PARTLY_CLEAR_DAY: 'cover_partlyclearday',
            COVER_PARTLY_CLEAR_NIGHT: 'cover_partlyclearnight',
            COVER_MOSTLY_CLOUDY_DAY: 'cover_mostlycloudyday',
            COVER_MOSTLY_CLOUDY_NIGHT: 'cover_mostlycloudynight',
            COVER_CLOUDY: 'cover_cloudy',
            VISIBILITY_HAZE_DAY: 'visibility_hazeday',
            VISIBILITY_HAZE_NIGHT: 'visibility_hazenight',
            VISIBILITY_MIST: 'visibility_mist',
            VISIBILITY_FOG: 'visibility_fog',
            VISIBILITY_FREEZING_FOG: 'visibility_freezingfog',
            VISIBILITY_BLOWING_SNOW: 'visibility_blowingsnow',
            VISIBILITY_DUST: 'visibility_dust',
            VISIBILITY_SMOKE: 'visibility_smoke',
            VISIBILITY_VOLCANIC_ASH: 'visibility_volcanicash',
            WIND_STRENGTH_WINDY: 'windstrength_windy',
            PRECIP_SPRINKLES: 'precip_sprinkles',
            PRECIP_RAIN: 'precip_rain',
            PRECIP_RAIN_SHOWERS: 'precip_rainshowers',
            PRECIP_HEAVY_RAIN: 'precip_heavyrain',
            PRECIP_THUNDERSTORM: 'precip_thunderstorm',
            PRECIP_THUNDER: 'precip_thunder',
            PRECIP_FLURRIES: 'precip_flurries',
            PRECIP_SNOW: 'precip_snow',
            PRECIP_SNOW_SHOWERS: 'precip_snowshowers',
            PRECIP_HEAVY_SNOW: 'precip_heavysnow',
            PRECIP_RAIN_SNOW: 'precip_rainsnow',
            PRECIP_FREEZING_RAIN: 'precip_freezingrain',
            PRECIP_ICE_PELLETS: 'precip_icepellets',
        }
    }
}


// WEBPACK FOOTER //
// ./shared/model/weather/WeatherModel.js